<template lang="pug">
	.audience-selection
		.header-data
			h2.content-block.header {{$tCaption('Audience selection')}}
		.widgets-area.segment
			DxResponsiveBox(:screen-by-width="screen", single-column-screen="xs sm")
				DxRow(:ratio="1")
				DxCol(:ratio="1")
				DxCol(:ratio="1")
				DxCol(:ratio="1")
				DxCol(:ratio="2")
				DxItem()
					DxLocation(:row="0", :col="0")
					template(v-slot:default)
						.widgets
							.widget
								.header {{$tCaption('Gender')}}
								.data-vertical
									DxCheckBox(:value="innerData.filterGenderMale", :text="$tCaption('Male')", @value-changed="(v) => innerData.filterGenderMale = v.value")
									DxCheckBox(:value="innerData.filterGenderFemale", :text="$tCaption('Female')", @value-changed="(v) => innerData.filterGenderFemale = v.value")
							.widget
								.header {{$tCaption('Education')}}
								.data-vertical
									DxCheckBox(:value="innerData.filterEducationNoCollege", :text="$tCaption('No college')", @value-changed="(v) => innerData.filterEducationNoCollege = v.value")
									DxCheckBox(:value="innerData.filterEducationCollege", :text="$tCaption('College')", @value-changed="(v) => innerData.filterEducationCollege = v.value")
									DxCheckBox(:value="innerData.filterEducationGradSchool", :text="$tCaption('Grad school')", @value-changed="(v) => innerData.filterEducationGradSchool = v.value")
				DxItem()
					DxLocation(:row="0", :col="1")
					template(v-slot:default)
						.widgets
							.widget
								.header {{$tCaption('Age')}}
								.data-vertical
									DxCheckBox(:value="innerData.filterAgeUnder18", :text="$tCaption('Under 18')", @value-changed="(v) => innerData.filterAgeUnder18 = v.value")
									DxCheckBox(:value="innerData.filterAge18_24", text="18 - 24", @value-changed="(v) => innerData.filterAge18_24 = v.value")
									DxCheckBox(:value="innerData.filterAge25_34", text="25 - 34", @value-changed="(v) => innerData.filterAge25_34 = v.value")
									DxCheckBox(:value="innerData.filterAge35_44", text="35 - 44", @value-changed="(v) => innerData.filterAge35_44 = v.value")
									DxCheckBox(:value="innerData.filterAge45_54", text="45 - 54", @value-changed="(v) => innerData.filterAge45_54 = v.value")
									DxCheckBox(:value="innerData.filterAge55_64", text="55 - 64", @value-changed="(v) => innerData.filterAge55_64 = v.value")
									DxCheckBox(:value="innerData.filterAgeOver65", :text="$tCaption('Over 65')", @value-changed="(v) => innerData.filterAgeOver65 = v.value")
				DxItem()
					DxLocation(:row="0", :col="2")
					template(v-slot:default)
						.widgets
							.widget
								.header {{$tCaption('Household annual income')}}
								.data-vertical
									DxCheckBox(:value="innerData.filterHouseholdUnder50", :text="$tCaption('Under $50k')", @value-changed="(v) => innerData.filterHouseholdUnder50 = v.value")
									DxCheckBox(:value="innerData.filterHousehold50_100", text="$50k - 100k", @value-changed="(v) => innerData.filterHousehold50_100 = v.value")
									DxCheckBox(:value="innerData.filterHousehold100_150", text="$100k - 150k", @value-changed="(v) => innerData.filterHousehold100_150 = v.value")
									DxCheckBox(:value="innerData.filterHouseholdOver150", :text="$tCaption('Over $150k')", @value-changed="(v) => innerData.filterHouseholdOver150 = v.value")
							.widget
								.header {{$tCaption('Parenting')}}
								.data-vertical
									DxCheckBox(:value="innerData.filterParentingNoKids", :text="$tCaption('No kids')", @value-changed="(v) => innerData.filterParentingNoKids = v.value")
									DxCheckBox(:value="innerData.filterParentingHasKids", :text="$tCaption('Has kids')", @value-changed="(v) => innerData.filterParentingHasKids = v.value")
				DxItem()
					DxLocation(:row="0", :col="3")
					template(v-slot:default)
						.widgets
							.widget
								.header {{$tCaption('Target audience size')}}
								.data-vertical
									DxPieChart(:data-source="audienceData",
										resolve-label-overlapping="shift",
										type="doughnut",
										:size="{ height: 280, width: 280 }", :rotated="true",
										:series="[pieChartSerieConfig()]",
										:legend="{ visible: false}",
										:inner-radius="0.65",
										:palette="['#dca0ff', '#ac7aca']",
										center-template="centerTemplate"
									)
										DxTooltip(:enabled="true", :zIndex="100000", format="thousands", :customizeTooltip="(e) => ({ text: `${e.valueText}\n${e.argument}` })")
										template(v-slot:centerTemplate="center")
											svg
												text(text-anchor="middle"
													x="100"
													y="120"
												)
													tspan(:style="{fontSize: 50, fontName: 'Roboto', fontWeight: 100, letterSpacing: '-4px' }", x="100") {{filteredAudiencePercent}}%
</template>

<script>
	import axios from 'axios';
	import _ from 'lodash';
	import VueTypes from 'vue-types';
	import {DxChart, DxSeries, DxLegend, DxSize, DxCommonSeriesSettings, DxTooltip, DxValueAxis, DxArgumentAxis, DxGrid, DxLabel, DxVisualRange, DxWholeRange, DxSeriesTemplate, DxFormat} from 'devextreme-vue/chart';
	import DxPieChart from 'devextreme-vue/pie-chart';
	import DxButton from 'devextreme-vue/button';
	import { DxResponsiveBox, DxItem, DxLocation, DxCol, DxRow } from 'devextreme-vue/responsive-box';
	import { DxCheckBox } from 'devextreme-vue/check-box';
	import api from '../carto/api.js';

	export default {
		translationCategory: 'proposal.AudienceSelection',
		name: 'audience-selection',
		components: {DxChart,
			DxSeries,
			DxLegend,
			DxSize,
			DxCommonSeriesSettings,
			DxTooltip, DxValueAxis,
			DxArgumentAxis,
			DxGrid,
			DxLabel,
			DxVisualRange,
			DxWholeRange,
			DxSeriesTemplate,
			DxFormat,
			DxButton,
			DxResponsiveBox,
			DxItem,
			DxLocation,
			DxCol,
			DxRow,
			DxPieChart,
			DxCheckBox
		},
		props: {
			data: VueTypes.object.def({}),
			regionsWhereClause: VueTypes.string.def(null)
		},
		data() {
			return {
				screen(width) {
					return (width < 900) ? 'xs' : 'lg';
				},
				ageTooltip: {
					enabled: true,
					format: (v) => `${v}`,
					showMode: 'always',
					position: 'bottom'
				},
				householdTooltip: {
					enabled: true,
					format: (v) => `$${v}K`,
					showMode: 'always',
					position: 'bottom'
				},
				filteredAudience: null,
				calculateTimer: null,
				calculateTimerDelay: 1000,
				innerData: _.clone(this.data)
			};
		},
		computed: {
			audienceData() {
				return [
                    { name: () => this.$tCaption('Other'), value: !this.filteredAudience ? 0 : (this.data.totalPopulation - this.filteredAudience) || 0 },
                    { name: () => this.$tCaption('Selected'), value: this.filteredAudience || this.data.totalPopulation }
                ];
			},
			filteredAudiencePercent() {
				return Math.floor(this.filteredAudience == null ? 100 : (100 * (this.filteredAudience || 0) / this.data.totalPopulation));
			}
		},
		watch: {
			innerData: {
				handler() {
					Object.keys(this.data).filter(f => f.startsWith('filter')).map(f => this.data[f] = this.innerData[f]);
					this.calculateFilteredAudience();
				},
				deep: true
			},
			filteredAudience(v) {
				this.data.selectedPopulation = v;
			}
		},
		mounted() {
			if (__DEBUG__)
				console.log('Audience selection mounted', this);
			this.calculateFilteredAudience();
		},
		methods: {
			pieChartSerieConfig() {
				return {
					argumentField: 'name',
					valueField: 'value',
					label: {
						visible: false,
						backgroundColor: 'none',
						format: 'fixedPoint',
						connector: {
							visible: true
						},
						customizeText: ({ argumentText }) => `${argumentText}`
					}
				};
			},
			calculateFilteredAudience() {
				if (this.calculateTimer)
					clearTimeout(this.calculateTimer);

				const data = [];
				const addFunc = (calcFields, groupFields, index) => {
					if (!calcFields || !calcFields.length) return;
					const prepareField = (field) => {
						if (field.fix) {
							return `sum(REPLACE(REPLACE(${field.name},',',''),'$','')::decimal)`;
						} else {
							return `sum(${field.name})`;
						}
					};
					data.push(`(${calcFields.map(f => prepareField(f)).join('+')})/(${groupFields.map(f => prepareField(f)).join('+')}) as field${index}`);
				};

				const groups = [
					[
						{ condition: this.innerData.filterGenderMale, name: 'a_male', fix: true },
						{ condition: this.innerData.filterGenderFemale, name: 'a_female', fix: true }
					],
					[
						{ condition: this.innerData.filterEducationNoCollege, name: 'a_no_colle' , fix: true},
						{ condition: this.innerData.filterEducationCollege, name: 'a_college', fix: true },
						{ condition: this.innerData.filterEducationGradSchool, name: 'a_graduate', fix: true }
					],
					[
						{ condition: this.innerData.filterParentingHasKids, name: 'a_with_k_1', fix: true },
						{ condition: this.innerData.filterParentingNoKids, name: 'a_no_kid', fix: true }
					],
					[
						{ condition: this.innerData.filterAgeUnder18, name: 'a_age_unde', fix: true },
						{ condition: this.innerData.filterAge18_24, name: 'a_age_18_2', fix: true },
						{ condition: this.innerData.filterAge25_34, name: 'a_age_25_3', fix: true },
						{ condition: this.innerData.filterAge35_44, name: 'a_age_35_4', fix: true },
						{ condition: this.innerData.filterAge45_54, name: 'a_age_45_5', fix: true },
						{ condition: this.innerData.filterAge55_64, name: 'a_age_55_6', fix: true },
						{ condition: this.innerData.filterAgeOver65, name: 'a_age_over', fix: true }
					],
					[
						{ condition: this.innerData.filterHouseholdUnder50, name: 'a_under_50', fix: true },
						{ condition: this.innerData.filterHousehold50_100, name: 'a_50k_100k', fix: true },
						{ condition: this.innerData.filterHousehold100_150, name: 'a_100k_150', fix: true },
						{ condition: this.innerData.filterHouseholdOver150, name: 'a_over_150', fix: true }
					]
				];

				groups.map((group, i) => {
					addFunc(group.filter(f => f.condition), group, i);
				});

				if (!data.length) {
					this.filteredAudience = this.data.totalPopulation;
					return;
				}

				this.calculateTimer = setTimeout(() => {
					if (this._isDestroyed) return;
					const query = `SELECT ${data.join(',')} FROM alluszipswithdata ${this.regionsWhereClause}`;
					if (__DEBUG__)
						console.log('Calculate filtered audience', { where: this.regionsWhereClause, data: this.innerData, query });
					axios.get(`https://${api.username}.carto.com/api/v2/sql?q=${encodeURIComponent(query)}`).then((response) => {
						if (__DEBUG__)
							console.log(response);

						let result = this.data.totalPopulation;
						for(var id in response.data.rows[0])
							result *= response.data.rows[0][id] || 1;
						this.filteredAudience = parseFloat(result).toFixed(0);
					});
				}, this.calculateTimerDelay);
			}
		}
	};
</script>
<style lang='scss'>
	.audience-selection {
	}
</style>
